var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.83,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#070203"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 894",
    d: "M8.915 0L0 14.264h17.83z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 524",
    d: "M5.349 8.821h7.132V32H5.349z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.d68d9605c6e20c85.svg";
export { ForwardRef as ReactComponent };